/**
 * 获取首页数据
 */
import request from "_private/utils/request";

let mock = "";

const requestAjax = function(rOpts) {
  let opts = {
    url: "",
    method: "post",
    headers: {
      type: "json"
    },
    data: {}
  };
  opts = Object.assign(opts, rOpts);
  return request({
    url: mock + opts.url,
    method: opts.method,
    headers: opts.headers,
    data: opts.data
  });
};

// 企业/车/库/柜变化趋势接口
export function FetchCountNumMonth() {
  return requestAjax({
    url: "/board/home/findCountNumMonth"
  });
}

// 不同行业企业数及占比接口
export function FetchCompanyNumAndRate() {
  return requestAjax({
    url: "/board/home/findCompanyNumAndRate"
  });
}

// 各地区企业数排行及占比接口
export function FetchCompanyNumAndRateByAreaName() {
  return requestAjax({
    url: "/board/home/findCompanyNumAndRateByAreaName"
  });
}

// 实时查询企业、今日新增企业、冷藏车、冷库、冷柜个数
export function FetchNumberByRealTime() {
  return requestAjax({
    url: "/board/home/findNumberByRealTime"
  });
}

// 实时查询各区县下企业、车辆、冷库、冷柜个数接口
export function FetchNumberByAreaName() {
  return requestAjax({
    url: "/board/home/findNumberByAreaName"
  });
}

// 综合在线率及温度合格率变化趋势接口
export function FetchOnlineAndQualifyRateByDay() {
  return requestAjax({
    url: "/board/home/findOnlineAndQualifyRateByDay"
  });
}

// 综合在线率及温度合格率排行 top3 接口
export function FetchCompanyOnlineAndQualifyTop3() {
  return requestAjax({
    url: "/board/home/findCompanyOnlineAndQualifyTop3"
  });
}

// 各地区在线率及温度合格率接口
export function FetchAreaOnlineAndQualify() {
  return requestAjax({
    url: "/board/home/findAreaOnlineAndQualifyByYesterday"
  });
}
// 冷藏车辆/冷库在线率接口
export function FetchVehicleOrStorageOnline(data) {
  return requestAjax({
    url: "/board/home/findAreaOnlineByScene",
    data
  });
}

// 地图接口
export function FetchMap() {
  return requestAjax({
    url: "/board/home/findMapLonLat"
  });
}

// 二级市，区，县数据
export function FetchCompanyInfoByCity(data) {
  return requestAjax({
    url: "/board/home/findCompanyInfoByCity",
    data
  });
}

// 同期省内冷藏车行驶里程对比
export function FetchVehicleData(data) {
  return requestAjax({
    url: "/board/home/provinceVehicleRunOdomContrast",
    data
  });
}
